import type {
  AgentGetPortfolioChartInput,
  AgentGetAgentTradePerformanceChartParams,
  AgentGetWalletPortfolioChartInput,
} from '../api'
import { api } from '../api'

export const getAgentPortfolio = async () => {
  return await api.v1.agentGetPortfolio()
}

export const getAgentPortfolioChart = async (
  data: AgentGetPortfolioChartInput,
) => {
  return await api.v1.agentGetPortfolioChart(data)
}

export const agentGetTradePerformance = async () => {
  return await api.v1.agentGetTradePerformance()
}

export const agentGetAgentTradePerformanceChart = async (
  data: AgentGetAgentTradePerformanceChartParams,
) => {
  return await api.v1.agentGetAgentTradePerformanceChart(data)
}

export const getAgentWalletPortfolioChart = async (
  data: AgentGetWalletPortfolioChartInput,
) => {
  return await api.v1.agentGetWalletPortfolioChart(data)
}
